import {faker} from '@faker-js/faker'

faker.seed(123)

export {faker} from '@faker-js/faker'
export const F = faker

export const nullable = <T>(fn: () => T, probability = 0.8) =>
  faker.helpers.maybe(fn, {probability}) ?? null

export const langsPool = [
  {code: 'en-US', label: 'English US'},
  {code: 'en-GB', label: 'English'},
  {code: 'es-ES', label: 'Spanish'},
  {code: 'fr-FR', label: 'French'},
  {code: 'de-DE', label: 'German'},
  {code: 'it-IT', label: 'Italian'},
  {code: 'ja-JP', label: 'Japanese'},
  {code: 'ko-KR', label: 'Korean'},
  {code: 'pt-BR', label: 'Portuguese Brazil'},
  {code: 'ru-RU', label: 'Russian'},
  {code: 'zh-CN', label: 'Chinese'},
  {code: 'ar-SA', label: 'Arabic'},
  {code: 'nl-NL', label: 'Dutch'},
  {code: 'fi-FI', label: 'Finnish'},
  {code: 'hi-IN', label: 'Hindi'},
  {code: 'id-ID', label: 'Indonesian'},
  {code: 'pl-PL', label: 'Polish'},
  {code: 'sv-SE', label: 'Swedish'},
  {code: 'tr-TR', label: 'Turkish'},
  {code: 'cs-CZ', label: 'Czech'},
  {code: 'da-DK', label: 'Danish'},
  {code: 'el-GR', label: 'Greek'},
  {code: 'he-IL', label: 'Hebrew'},
  {code: 'hu-HU', label: 'Hungarian'},
  {code: 'ms-MY', label: 'Malay'},
  {code: 'no-NO', label: 'Norwegian Bokmal'},
  {code: 'ro-RO', label: 'Romanian'},
  {code: 'sk-SK', label: 'Slovak'},
  {code: 'th-TH', label: 'Thai'},
  {code: 'uk-UA', label: 'Ukrainian'},
  {code: 'vi-VN', label: 'Vietnamese'},
] as const
